import React, { useContext } from 'react';
import { createContext } from 'react';

import { User } from '@utils/backend-api/currentUser';

enum RailsEnv {
  Test = 'test',
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}
/* eslint-disable  @typescript-eslint/no-explicit-any */
// If you modify this list make sure to maintain parity with the server side
// env helper: `app/helpers/application_helper.rb`
export interface Env {
  GOOGLE_CLIENT_ID?: string;
  IMGIX_ENV?: string;
  IMGIX_URL?: string;
  READ_ONLY_MODE?: string;
  READ_ONLY_PHRASE?: string;
  READER_URL?: string;
  RAILS_ENV?: RailsEnv;
  RECAPTCHA_SITE_KEY?: string;
  SHOW_MODAL_ON_INACTION_SECONDS?: string;
  SUBSCRIPTIONS_URL?: string;
  STRIPE_PUBLISH_KEY?: string;
}

type AppContextType = {
  env: Env;
  initialCurrentUser?: User;
  isWebview: boolean;
};

const AppContext = createContext<AppContextType>({
  env: {},
  isWebview: false,
});

export const AppContextProvider = ({
  env,
  initialCurrentUser,
  isWebview = false,
  children,
}: {
  env: Env;
  initialCurrentUser?: User;
  isWebview: boolean;
  children: React.ReactNode;
}) => {
  const value = { env, initialCurrentUser, isWebview };
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  return context;
};
